import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { LeftNavigationComponent } from '../left-navigation/left-navigation.component';
import { ChatViewModule } from '../../../modules/chat-view/chat-view.module';
import { StreamingViewModule } from '../../../modules/streaming-view/streaming-view.module';

@Component({
    selector: 'craig-content',
    standalone: true,
    imports: [RouterOutlet, LeftNavigationComponent, ChatViewModule, StreamingViewModule],
    templateUrl: './content.component.html',
    styleUrls: ['./content.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentComponent {
    @Input() isStreamingEnabled: boolean = false;
}
